import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Outlet } from 'react-router-dom'
import { ScrollToTop } from './components/ScrollToTop'

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ScrollToTop />
      <Outlet />
    </QueryClientProvider>
  )
}

export default App
